import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { auth, googleProvider } from '../firebase'; // Import googleProvider
import { signInWithEmailAndPassword, signInWithPopup, signOut } from 'firebase/auth'; // Import signInWithPopup & signOut
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const navigate = useNavigate();

  // --- NEW: Google Login Logic ---
  const handleGoogleLogin = async () => {
    setIsLoggingIn(true);
    setError('');

    try {
      const result = await signInWithPopup(auth, googleProvider);

      // SECURITY CHECK: Is this the authorized Admin?
      // Replace this email with your actual Google account email!
      if (result.user.email !== 'sales@bunnyboutique321.com') {
        await signOut(auth); // Immediately kick them out
        setError('Access Denied: You do not have administrator privileges.');
        setIsLoggingIn(false);
        return;
      }

      navigate('/admin'); // If it is you, let them in!
    } catch (error) {
      // Handles cases where the user closes the popup before logging in
      if (error.code !== 'auth/popup-closed-by-user') {
        setError('Google sign-in failed. Please try again.');
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  // --- Existing Email/Password Logic ---
  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setIsLoggingIn(true);
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin');
    } catch (error) {
      setError('Invalid email or password. Please try again.');
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Helmet>
        <title>Admin Login | Bunny Boutique 321</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', width: '100%', maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#07162c' }}>Admin Access</h2>

        {error && (
          <div style={{ backgroundColor: '#fee2e2', color: '#991b1b', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center', fontSize: '0.9rem' }}>
            {error}
          </div>
        )}

        {/* NEW: Google Auth Button */}
        <button
          onClick={handleGoogleLogin}
          disabled={isLoggingIn}
          style={{
            width: '100%', padding: '12px', marginBottom: '20px',
            backgroundColor: '#ffffff', color: '#333',
            border: '1px solid #ccc', borderRadius: '8px',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
            fontWeight: 'bold', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
          }}
        >
          {/* Simple Google "G" Logo */}
          <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          {isLoggingIn ? 'Verifying...' : 'Sign in with Google'}
        </button>

        <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0', color: '#999' }}>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#eee' }}></div>
          <span style={{ padding: '0 10px', fontSize: '0.85rem' }}>OR</span>
          <div style={{ flex: 1, height: '1px', backgroundColor: '#eee' }}></div>
        </div>

        {/* Existing Email Form */}
        <form onSubmit={handleEmailLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div className="form-group" style={{ marginBottom: '0' }}>
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>

          <div className="form-group" style={{ marginBottom: '0' }}>
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>

          <button type="submit" className="btn-primary" disabled={isLoggingIn} style={{ width: '100%', marginTop: '10px' }}>
            {isLoggingIn ? 'Logging in...' : 'Sign In with Email'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;